module.exports = __webpack_public_path__ + "487e77ed2d90c5ed21e2a1c0e391a59f.jpg";